<!-- HEADER -->
<app-header color="transparent"></app-header>

<!-- CONTENT -->
<ion-content class="padded" [class.isTablet]="tablet && !desktop">
  <section *ngIf="data">
    <!-- BREADCRUMBS -->
    <ul class="breadcrumb">
      <li>
        <a [routerLink]="'/'">Home</a
        ><ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li>
        <a [routerLink]="'/shops'">Shops</a
        ><ion-icon name="chevron-forward-outline"></ion-icon>
      </li>
      <li class="active">{{data?.store.title}}</li>
    </ul>

    <!-- SHOP OVERVIEW -->
    <section class="shop-overview">
      <ion-grid class="ion-no-padding ion-no-margin">
        <ion-row>
          <ion-col size="12" size-md="7" *ngIf="desktop">
            <ion-row class="ion-align-items-center ion-margin-bottom">
              <!-- TITLE -->
              <ion-col>
                <h1 class="h2 shop-title">{{data.store.title}}</h1>
              </ion-col>

              <!-- FAVORTIE & SHARE -->
              <ion-col size="auto" class="favorite">
                <app-favorite-item
                  [title]="data.store.title"
                  [slug]="data.store.slug"></app-favorite-item>
              </ion-col>
              <ion-col size="auto" class="social-share">
                <a (click)="presentPopover($event)">
                  <ion-icon
                    color="dark"
                    name="share-outline"
                    slot="icon-only"></ion-icon>
                </a>
              </ion-col>
            </ion-row>
            <!-- CATEGORY -->
            <ion-text color="tertiary">
              <h2 class="shop-category">
                {{data.store.category?.title}}<ng-container
                  *ngIf="data.store.subCategories">
                  <span *ngFor="let subCat of data.store.subCategories">
                    <ng-container *ngIf="subCat.child; else parentSubCat"
                      >, {{subCat.child.title}}</ng-container
                    >
                    <ng-template #parentSubCat>, {{subCat.title}}</ng-template>
                  </span>
                </ng-container>
              </h2>
            </ion-text>
          </ion-col>
        </ion-row>
        <ion-row>
          <!-- DESKTOP LOGO -->
          <ion-col size="12" size-md="7" *ngIf="desktop">
            <div
              class="shop-img-wrapper ion-align-items-center ion-justify-content-center">
              <app-img-format
                [aspectRatio]="'16:9'"
                [disableLazyLoad]="true"
                *ngIf="data?.store.logoImage"
                [src]="data.store.logoImage"
                [alt]="data.store.title + ' in ' + environmentName"></app-img-format>
            </div>

            <!-- HEADING -->
            <ion-text
              *ngIf="data?.store?.typeGeneral?.store_description && desktop && !mobile"
              color="dark">
              <p class="display">
                {{data.store.typeGeneral.store_description}}
              </p>
            </ion-text>

            <!-- AMENITIES -->
            <section class="options-listing" *ngIf="amenities && desktop">
              <ion-text color="dark">
                <h3 class="options-listing-title">Amenities</h3>
              </ion-text>
              <ion-grid>
                <ion-row>
                  <ng-container *ngFor="let preference of amenities">
                    <ion-col size="12" size-md="4" class="ion-no-padding">
                      <ion-item>
                        <app-services-icon
                          [icon]="preference.icon"></app-services-icon>
                        <ion-text color="dark">{{preference.name}}</ion-text>
                      </ion-item>
                    </ion-col>
                  </ng-container>
                </ion-row>
              </ion-grid>
            </section>

            <!-- DIETARY PREFERENCES -->
            <section
              class="options-listing"
              *ngIf="dietaryPreferences && desktop && !mobile">
              <ion-text color="dark">
                <h3 class="options-listing-title">Dietary Preferences</h3>
              </ion-text>
              <ion-grid>
                <ion-row>
                  <ng-container *ngFor="let preference of dietaryPreferences">
                    <ion-col size="12" size-md="4" class="ion-no-padding">
                      <ion-item>
                        <app-services-icon
                          [icon]="preference.icon"></app-services-icon>
                        <ion-text color="dark">{{preference.name}}</ion-text>
                      </ion-item>
                    </ion-col>
                  </ng-container>
                </ion-row>
              </ion-grid>
            </section>

            <!-- SERVICES -->
            <section
              class="options-listing"
              *ngIf="services && desktop && !mobile">
              <ion-text color="dark">
                <h3 class="options-listing-title">Services</h3>
              </ion-text>
              <ion-grid>
                <ion-row>
                  <ng-container *ngFor="let service of services">
                    <ion-col size="12" size-md="4" class="ion-no-padding">
                      <ion-item>
                        <app-services-icon
                          [icon]="service.icon"></app-services-icon>
                        <ion-text color="dark">{{service.name}}</ion-text>
                      </ion-item>
                    </ion-col>
                  </ng-container>
                </ion-row>
              </ion-grid>
            </section>

            <!-- PAYMENT OPTIONS -->
            <section
              class="options-listing"
              *ngIf="paymentOptions && desktop && !mobile">
              <ion-text color="dark">
                <h3 class="options-listing-title">Payment Options</h3>
              </ion-text>
              <ion-grid>
                <ion-row>
                  <ng-container *ngFor="let payment of paymentOptions">
                    <ion-col size="12" size-md="4" class="ion-no-padding">
                      <ion-item>
                        <app-services-icon
                          [icon]="payment.icon"></app-services-icon>
                        <ion-text color="dark">{{payment.name}}</ion-text>
                      </ion-item>
                    </ion-col>
                  </ng-container>
                </ion-row>
              </ion-grid>
            </section>
          </ion-col>

          <ion-col size="12" *ngIf="!desktop">
            <ion-row class="ion-align-items-center ion-margin-bottom">
              <!-- TITLE -->
              <ion-col>
                <h1 class="h2 shop-title">{{data.store.title}}</h1>
              </ion-col>

              <!-- FAVORTIE & SHARE -->
              <ion-col size="auto" class="favorite">
                <app-favorite-item
                  [title]="data.store.title"
                  [slug]="data.store.slug"></app-favorite-item>
              </ion-col>
              <ion-col size="auto" class="social-share">
                <a (click)="presentPopover($event)">
                  <ion-icon
                    color="dark"
                    name="share-outline"
                    slot="icon-only"></ion-icon>
                </a>
              </ion-col>
            </ion-row>

            <!-- CATEGORY -->
            <ion-text color="tertiary">
              <h2 class="shop-category">
                {{data.store.category?.title}}<ng-container
                  *ngIf="data.store.subCategories">
                  <span *ngFor="let subCat of data.store.subCategories">
                    <ng-container *ngIf="subCat.child; else parentSubCat"
                      >, {{subCat.child.title}}</ng-container
                    >
                    <ng-template #parentSubCat>, {{subCat.title}}</ng-template>
                  </span>
                </ng-container>
              </h2>
            </ion-text>
          </ion-col>

          <ion-col size="12" size-md class="shop-overview-details">
            <!-- DIRECITONS -->
            <div class="shop-directions" *ngIf="desktop">
              <ion-text color="tertiary">
                <h2 class="shop-category">
                  Shop {{data.store.typeGeneral.store_number}},
                  {{data.store.typeGeneral.level}}
                  <ng-container *ngIf="!!!data.store?.typeGeneral?.booking_url">
                    | Entrance {{data.store.typeGeneral.entrance}}
                  </ng-container>
                </h2>
              </ion-text>
              <ion-grid>
                <ion-row>
                  <ion-col>
                    <app-button
                      type="secondary"
                      [icon]="mapIcon"
                      [fullWidth]="true"
                      (click)="presentMapModal()">
                      View on map
                    </app-button>
                  </ion-col>
                  <ion-col>
                    <app-button
                      type="secondary"
                      [icon]="directionsIcon"
                      [fullWidth]="true"
                      (click)="presentMapModal(true)">
                      Get Directions
                    </app-button>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>

            <!-- MOBILE LOGO -->
            <div
              *ngIf="!desktop"
              class="shop-img-wrapper ion-align-items-center ion-justify-content-center">
              <app-img-format
                [aspectRatio]="'16:9'"
                [disableLazyLoad]="true"
                *ngIf="data?.store.logoImage"
                [src]="data.store.logoImage"
                [alt]="data.store.title + ' in ' + environmentName"></app-img-format>
            </div>

            <!-- DIRECITONS -->
            <div class="shop-directions" *ngIf="!desktop">
              <ion-text color="tertiary">
                <h2 class="shop-category">
                  Shop {{data.store.typeGeneral.store_number}},
                  {{data.store.typeGeneral.level}}
                  <ng-container *ngIf="!!!data.store?.typeGeneral?.booking_url">
                    | Entrance {{data.store.typeGeneral.entrance}}
                  </ng-container>
                </h2>
              </ion-text>
              <ion-grid>
                <ion-row>
                  <ion-col>
                    <app-button
                      type="secondary"
                      [icon]="mapIcon"
                      [fullWidth]="true"
                      (click)="presentMapModal()">
                      View on map
                    </app-button>
                  </ion-col>
                  <ion-col>
                    <app-button
                      type="secondary"
                      [icon]="directionsIcon"
                      [fullWidth]="true"
                      (click)="presentMapModal(true)">
                      Get Directions
                    </app-button>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>

            <!-- STORE CURRENTLY OPEN/CLOSED -->
            <ion-text color="tertiary" class="shop-open">
              <h2 class="shop-category">
                Trading Hours -
                <ng-container
                  *ngIf="data?.store.typeGeneral.new && data?.store.currentStatus.toLowerCase().includes('open')">
                  New Store |
                </ng-container>
                <ng-container
                  *ngIf="data?.store.typeGeneral.popup && data?.store.currentStatus.toLowerCase().includes('open')">
                  Pop-Up |
                </ng-container>
                {{data?.store.currentStatus}}
              </h2>
            </ion-text>

            <!-- OPENING TIMES -->
            <ion-grid class="shop-time-list ion-no-padding">
              <ion-row *ngFor="let day of data?.store.typeTrading">
                <ion-col sizeMd="4" sizeXs="6">
                  <ng-container *ngIf="day.seasonsName">
                    {{day.seasonsName}} |
                  </ng-container>
                  {{day.dayName}}
                </ion-col>
                <ion-col size="auto">
                  <ion-text>
                    <span *ngIf="day.open; else closedDay">
                      {{day.open_text}} - {{day.close_text}}
                    </span>
                    <ng-template #closedDay>
                      <span>Closed</span>
                    </ng-template>
                  </ion-text>
                </ion-col>
              </ion-row>
            </ion-grid>

            <!-- SPECIAL DAYS -->
            <ion-grid class="shop-time-list ion-no-padding">
              <ion-row *ngFor="let day of getUpcomingDays()">
                <ion-col sizeMd="4" sizeXs="6">
                  <ion-text color="medium">
                    {{day.label}} | {{day.date | date:"d MMM"}}
                  </ion-text>
                </ion-col>
                <ion-col size="auto">
                  <ng-container *ngIf="!day.isDay; else specialDayClosed">
                    <ion-text color="medium">
                      <span> {{day.openTime}} - {{day.closeTime}} </span>
                    </ion-text>
                  </ng-container>
                  <ng-template #specialDayClosed>
                    <ion-text color="medium">
                      <span> Closed </span>
                    </ion-text>
                  </ng-template>
                </ion-col>
              </ion-row>
            </ion-grid>

            <ion-text color="tertiary" class="shop-open">
              <h2 class="shop-category">Contact Store</h2>
            </ion-text>
            <!-- SHOP DETAILS -->
            <section class="shop-details">
              <app-button
                *ngIf="data.store.typeGeneral.email_address"
                [href]="'mailto:'+data.store.typeGeneral.email_address"
                type="text"
                [icon]="emailIcon"
                target="_blank">
                {{data.store.typeGeneral.email_address}}
              </app-button>
              <app-button
                *ngIf="data.store.typeGeneral.telephone_number"
                [href]="desktop ? undefined : 'tel:'+data.store.typeGeneral.telephone_number"
                type="text"
                [icon]="phoneIcon"
                target="_blank">
                {{data.store.typeGeneral.telephone_number}}
              </app-button>
              <app-button
                *ngIf="websiteUrl"
                [href]="websiteUrl"
                type="text"
                [icon]="websiteBookingIcon"
                target="_blank">
                {{data.store.typeGeneral.website}}
              </app-button>
              <app-button
                *ngIf="websiteUrl && data.store?.typeGeneral?.booking_url"
                [href]="data.store.typeGeneral.booking_url"
                type="text"
                [icon]="websiteBookingIcon"
                target="_blank">
                Bookings
              </app-button>
            </section>
          </ion-col>
        </ion-row>
      </ion-grid>
    </section>

    <section class="shop-content">
      <!-- HEADING -->
      <ion-text
        *ngIf="data?.store?.typeGeneral?.store_description && mobile"
        color="dark">
        <h2>About</h2>
        <p class="display">{{data.store.typeGeneral.store_description}}</p>
      </ion-text>

      <!-- AMENITIES -->
      <section class="options-listing" *ngIf="amenities && !desktop">
        <ion-text color="dark">
          <h3 class="options-listing-title">Amenities</h3>
        </ion-text>
        <ion-grid>
          <ion-row>
            <ng-container *ngFor="let preference of amenities">
              <ion-col size="12" size-md="4" class="ion-no-padding">
                <ion-item>
                  <app-services-icon
                    [icon]="preference.icon"></app-services-icon>
                  <ion-text color="dark">{{preference.name}}</ion-text>
                </ion-item>
              </ion-col>
            </ng-container>
          </ion-row>
        </ion-grid>
      </section>

      <!-- DIETARY PREFERENCES -->
      <section class="options-listing" *ngIf="dietaryPreferences && !desktop">
        <ion-text color="dark">
          <h3 class="options-listing-title">Dietary Preferences</h3>
        </ion-text>
        <ion-grid>
          <ion-row>
            <ng-container *ngFor="let preference of dietaryPreferences">
              <ion-col size="12" size-md="4" class="ion-no-padding">
                <ion-item>
                  <app-services-icon
                    [icon]="preference.icon"></app-services-icon>
                  <ion-text color="dark">{{preference.name}}</ion-text>
                </ion-item>
              </ion-col>
            </ng-container>
          </ion-row>
        </ion-grid>
      </section>

      <!-- SERVICES -->
      <section class="options-listing" *ngIf="services && !desktop">
        <ion-text color="dark">
          <h3 class="options-listing-title">Services</h3>
        </ion-text>
        <ion-grid>
          <ion-row>
            <ng-container *ngFor="let service of services">
              <ion-col size="12" size-md="4" class="ion-no-padding">
                <ion-item>
                  <app-services-icon [icon]="service.icon"></app-services-icon>
                  <ion-text color="dark">{{service.name}}</ion-text>
                </ion-item>
              </ion-col>
            </ng-container>
          </ion-row>
        </ion-grid>
      </section>

      <!-- PAYMENT OPTIONS -->
      <section class="options-listing" *ngIf="paymentOptions && !desktop">
        <ion-text color="dark">
          <h3 class="options-listing-title">Payment Options</h3>
        </ion-text>
        <ion-grid>
          <ion-row>
            <ng-container *ngFor="let payment of paymentOptions">
              <ion-col size="12" size-md="4" class="ion-no-padding">
                <ion-item>
                  <app-services-icon [icon]="payment.icon"></app-services-icon>
                  <ion-text color="dark">{{payment.name}}</ion-text>
                </ion-item>
              </ion-col>
            </ng-container>
          </ion-row>
        </ion-grid>
      </section>

      <!-- BODY -->
      <app-dynamic-html
        [data]="data?.store.body"
        [formTitle]="data.store.title"></app-dynamic-html>
    </section>

    <!-- RELATED CONTENT -->
    <section
      class="related-content ion-content-stretched swiper-stretched"
      *ngIf="data?.relatedContent && data?.relatedContent.length > 0">
      <ion-text color="dark" class="ion-text-center">
        <h2 class="related-content-title">Related Content</h2>
      </ion-text>
      <ion-slides pager="true" [options]="slideOpts">
        <ion-slide
          *ngFor="let item of data?.relatedContent"
          class="ion-align-items-start ion-justify-content-start">
          <app-card
            [data]="item"
            [showType]="true"
            [img]="{ url: item.featuredImage, alt: item.title, aspectRatio: '16:9' }"
            [hidePrice]="true"></app-card>
        </ion-slide>
      </ion-slides>
    </section>
  </section>

  <!-- SIMILAR STORES -->
  <section
    *ngIf="data?.relatedStores && data?.relatedStores.length > 0"
    class="stores-listing ion-content-stretched swiper-stretched">
    <ion-grid>
      <ion-text color="dark" class="ion-text-center">
        <h2 class="related-content-title">Similar Stores</h2>
      </ion-text>
      <ion-row class="ion-nowrap ion-align-items-start">
        <ion-slides pager="true" [options]="slideOpts">
          <ion-slide *ngFor="let item of data.relatedStores">
            <ion-card
              (click)="linkToDetail(item)"
              class="card-boxed card-boxed-mobile">
              <div *ngIf="item.logoImage" class="card-img">
                <app-img-format
                  [src]="item.logoImage"
                  [aspectRatio]="'16:9'"
                  [alt]="item.title + ' in ' + environmentName"
                  [disableLazyLoad]="true"></app-img-format>
              </div>
              <ion-card-header>
                <ion-card-subtitle>
                  <ng-container
                    *ngIf="item.typeGeneral.new && item.currentStatus.toLowerCase().includes('open')">
                    New Store |
                  </ng-container>
                  {{item.currentStatus}}
                  <ng-container
                    *ngIf="item.currentStatus && item.currentStatus.toLowerCase().includes('open')">
                    | {{ storeOpenClose(item) }}
                  </ng-container>
                </ion-card-subtitle>
                <ion-card-title>{{item.title}}</ion-card-title>
              </ion-card-header>
              <ion-card-content>
                {{item.typeGeneral.telephone_number}} |
                {{item.typeGeneral.level}}
              </ion-card-content>
            </ion-card>
          </ion-slide>
        </ion-slides>
      </ion-row>
    </ion-grid>
  </section>

  <!-- FOOTER -->
  <app-footer></app-footer>
</ion-content>
